import { useState } from 'react';
import { cx } from '@emotion/css';
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';

import InformationCircle from '@new-components/shapes/InformationCircle';

import { ApplicationAlertProps } from './types';
import { alertCx, collapseCx } from './styles';

const ApplicationAlert = (props: ApplicationAlertProps) => {
  const { className, message, marginBottom, style, ...resProps } = props;
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Collapse
      in={isOpen}
      className={cx('application-alert', collapseCx, className)}
      style={{ ...style, marginBottom }}
      {...resProps}
    >
      <Alert
        severity='info'
        className={alertCx}
        onClose={() => setIsOpen(false)}
        icon={<InformationCircle />}
      >
        {message}
      </Alert>
    </Collapse>
  );
};

export default ApplicationAlert;
